<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel'   //Save Excel
                    ]"
                    @btnRetrieve="btnRetrieve()"
                    @btnExcel="onExporting()"
                  > 
                  <template v-slot:body>
                      <v-row>
                        <v-col cols="12">
                        </v-col>
                      </v-row>
                    </template>                  
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">                  
                  <DxDataGrid id="epms7050" 
                    class="listBox" 
                    :ref="epms7050Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"                  
                  >                
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="rwno" caption="No" width="3%" data-type="string" alignment="center" :visible="true" :allow-editing="false" />
                    <DxColumn data-field="grpSpec" caption="Specification" width="17%" data-type="string" alignment="left" :allow-editing="false" />
                    <DxColumn data-field="unit" caption="Unit" width="3%" data-type="string" alignment="center" :allow-editing="false" />                    
                    <DxColumn data-field="" caption="Contract Price" width="10%" data-type="string" alignment="center" :allow-editing="false" >                      
                      <DxColumn data-field="proAmt" caption="Prod." width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="pntAmt" caption="Paint" width="10%" data-type="number" format="#,###"  alignment="right" :allow-editing="false" />
                      <DxColumn data-field="spAmt" caption="S.Prime" width="10%" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="sepAmt" caption="Material" width="10%" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="galAmt" caption="Gal." width="10%" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                      <DxColumn data-field="trmAmt" caption="Treatment" width="10%" data-type="number" format="#,###" alignment="right" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="" caption="Contract Duration" width="10%" data-type="string" alignment="center" :allow-editing="false" >                      
                      <DxColumn data-field="frDte" caption="From Date" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="toDte" caption="To Date" width ="10%" data-type="string" alignment="center" :allow-editing="false" />                     
                    </DxColumn>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton , DxExport } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getDateFormat, getCurrentDate, getPreMonth , getFirstDay} from '@/utils/common.js'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getUPGrpList } from '@/api/view/hip/1/epms7050.js'

export default {
  name: 'epms7050',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,      

      epms7050Ref: 'epms7050Ref',
      gridMainList: [{a: '2022/12/05', id: 1 , test: "N"}],

      //cell merge
      mergeElements: [],
      mergeStartElements: [],

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms7050Ref)
    },
  },
  methods: {
    getStrFormat(date) {
      this.stDte = getDateFormat(date)
      return getDateFormat(date)
    },
    getEndFormat(date) {
      this.edDte = getDateFormat(date)
      return getDateFormat(date)
    },
    btnRetrieve(){     

      this.doSearchMain()

    },
    async doSearchMain(){
      this.openLoading('searching')
      console.log("doSearchMain")  
      
      let params = {
        makerCd: this.$store.state.user.makerCd,          
        
      }
      console.log(params)     

      await getUPGrpList(params).then(res => {
        // res.list.forEach(e => {
        //   e.id = e.rnum
        // });        
        this.gridMainList = res.list
      }).finally(() => {
        this.endLoading()
      })

    },      
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Unit Price by material Group List');

      exportDataGrid({
        component: this.gridMainInstance,
        worksheet,
        topLeftCell: { row: 1, column: 1 },
      }).then((cellRange) => {
        const headerRow = worksheet.getRow(1);
        const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
        const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
        let headerRowLength = headerRow._cells.length
        for(let i = 1; i <= headerRowLength; i++){
          headerRow.getCell(i).fill = headerStyle
          headerRow.getCell(i).border = headerBorderStyle
          headerRow.getCell(i).alignment = { horizontal: 'center' }
        }
        for(let j = 2; j <= worksheet._rows.length; j++){
          for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
            worksheet.getRow(j).getCell(a).border = headerBorderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'UnitCtrUPrc.xlsx');
        });
      });
      this.gridMainInstance.cancel = true;
    },
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }    
  .v-btn {
    text-transform: unset !important;
    // height: 16px !important;
  }
</style>
